module.exports = __webpack_public_path__ + "img/Faulenzen.eb1a1f21.jpg";